// super-excalidraw: thin client for the server-side Giphy proxy (/api/gifs/search).
// The Go server holds GIPHY_API_KEY so the key never reaches the browser.

export interface GiphyGif {
  id: string;
  title: string;
  previewUrl: string; // fixed_height_small — small animated GIF for the grid
  url: string;        // downsized_medium — inserted onto the canvas
  width: number;
  height: number;
}

function mapGifs(data: { data?: any[] }): GiphyGif[] {
  return (data.data ?? []).map((g: any) => ({
    id: g.id,
    title: g.title,
    previewUrl: g.preview_url,
    url: g.url,
    width: g.width,
    height: g.height,
  }));
}

export async function searchGifs(
  q: string,
  limit = 24,
  offset = 0,
): Promise<GiphyGif[]> {
  if (!q.trim()) return [];
  const params = new URLSearchParams({
    q: q.trim(),
    limit: String(limit),
    offset: String(offset),
  });
  const r = await fetch(`/api/gifs/search?${params}`);
  if (!r.ok) {
    if (r.status === 503) return []; // GIPHY_API_KEY not configured
    throw new Error(`gif search failed: ${r.status}`);
  }
  return mapGifs(await r.json());
}

// Trending GIFs — shown in the GIFs tab before the user searches anything.
export async function trendGifs(limit = 24, offset = 0): Promise<GiphyGif[]> {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  const r = await fetch(`/api/gifs/trending?${params}`);
  if (!r.ok) {
    if (r.status === 503) return []; // GIPHY_API_KEY not configured
    throw new Error(`gif trending failed: ${r.status}`);
  }
  return mapGifs(await r.json());
}
